import {
  FC,
  createContext,
  useContext,
  useState,
  PropsWithChildren,
} from 'react'

type Section = {
  element: HTMLDivElement
  title: string
}

type NavigationContextType = {
  sections: Section[]
  addSection: (section: Section) => void
}

const NavigationContext = createContext<NavigationContextType | null>(null)

export const NavigationContextProvider: FC<PropsWithChildren> = ({
  children,
}) => {
  const [sections, setSections] = useState<Section[]>([])
  const addSection = (section: Section) =>
    setSections((s) => {
      if (s.find((s) => s.title === section.title)) {
        return s
      }

      return [...s, section]
    })

  return (
    <NavigationContext.Provider
      value={{
        sections,
        addSection,
      }}
    >
      {children}
    </NavigationContext.Provider>
  )
}

export const useNavigationContext = () => {
  const context = useContext(NavigationContext)
  return context as NavigationContextType
}
